
<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="disabled"
        
        text
        v-bind="attrs"
        v-on="on"
      >
        Tilbakestill alle filter
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="pa-4 text-h6">
        Er du sikker på at du ønsker å nullstille alle filter?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn
            text
            @click="dialog = false"
          >Nei</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="emitResetAllFilters"
          >Ja</v-btn>
        </v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "FilterResetDialog",
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    emitResetAllFilters () {
      this.$eventHub.$emit("reset-all-filters", {});
      this.dialog = false;
    }
  },
  props: {
    disabled: Boolean
  }
};
</script>
<style>

</style>
